import React, { useEffect, createContext, useContext, useReducer } from 'react'
import FORWARD from '../../helpers/forward_button_types'
import activityNavReducer from '../../pages/Activity/ActivityNav/activityNavReducer'
import useIsComponentMounted from '../../hooks/useIsComponentMounted'

export const ActivityNavContext = createContext()
export const useActivityNavContext = () => useContext(ActivityNavContext)

export default function ActivityNavProvider({ children }) {
  const isComponentMountedRef = useIsComponentMounted()
  const initialValues = {
    backVisible: false,
    forwardMode: FORWARD.SKIP,
    forwardDisabled: false,
    previousCallback: () => {},
    nextCallback: () => {},
    doneCallback: () => {},
    saveCallback: () => {},
  }
  const [state, dispatch] = useReducer(activityNavReducer, initialValues)

  const useUpdateNavigationState = ({ isActive, updates }) => {
    useEffect(() => {
      if (isActive && isComponentMountedRef.current) {
        dispatch({ actionType: `SET_UPDATES`, updates })
      }
    }, [isActive, updates])
  }

  return (
    <ActivityNavContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        ...state,
        dispatch,
        useUpdateNavigationState,
      }}
    >
      {children}
    </ActivityNavContext.Provider>
  )
}
